import { PAGE_NAMES, BULK_ACTIONS_RESOURCES, ACTION } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermissionV2 } = params;

	return {
		bulkActions: [],
		rowActions: [],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermissionV2({
					configPageName: PAGE_NAMES.bulkActions,
					configResourceName: BULK_ACTIONS_RESOURCES.bulkReply,
					configActionName: ACTION.executeBulkReply
				});
			}
		}
	};
};

export default {
	makeActionList
};
